module.exports = __webpack_public_path__ + "static/media/medical-diagnosis.15525dbc.svg";